export const works = [
  {
    id: "wushong-1982",
    title: "武松",
    year: "1982",
    type: "电影",
    director: "李翰祥",
    cast: "汪萍 饰 潘金莲",
    tag: "金马奖最佳女主角",
    summary:
      "以武松的视角展开，潘金莲被塑造为情欲与命运交织的悲剧人物。影片舞台化的布景与浓烈色彩，让这个角色第一次在银幕上拥有了强烈而完整的存在感。",
    detail:
      "该片是较早把潘金莲作为核心人物来书写的电影之一，汪萍也凭此角获得第19届金马奖最佳女主角，成为潘金莲银幕形象演变中常被提及的节点。",
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20Chinese%20martial%20arts%20film%20poster%20style%2C%20dramatic%20courtyard%20with%20red%20lanterns%20at%20night%2C%20a%20woman%20in%20classical%20robe%20standing%20beside%20a%20wooden%20lattice%20window%2C%20warm%20crimson%20and%20gold%20tones%2C%20grainy%20painterly%20illustration%2C%20cinematic%20negative%20space&width=600&height=800&seq=panjinlian-w01&orientation=portrait",
  },
  {
    id: "qianshi-1989",
    title: "潘金莲之前世今生",
    year: "1989",
    type: "电影",
    director: "罗卓瑶",
    cast: "王祖贤 饰 单玉莲（前世潘金莲）",
    tag: "李碧华原著改编",
    summary:
      "把潘金莲的转世放进现代都市，让古典的情欲与命运议题与当下的生活相遇。影片用双重时空的叙事，追问一个人能否摆脱注定的标签。",
    detail:
      "改编自李碧华同名小说，借“前世今生”的结构重新审视潘金莲，是影视形象演变中较早尝试以现代视角重读这一角色的作品。",
    image:
      "https://readdy.ai/api/search-image?query=Dreamy%20double%20exposure%20portrait%20of%20a%20woman%20blending%20classical%20Chinese%20hanfu%20and%20modern%20city%20lights%2C%20moody%20warm%20crimson%20and%20amber%20tones%2C%20stylized%20cinematic%20poster%20illustration%2C%20melancholic%20atmosphere%2C%20soft%20grain&width=600&height=800&seq=panjinlian-w02&orientation=portrait",
  },
  {
    id: "hensuo-1994",
    title: "恨锁金瓶",
    year: "1994",
    type: "电视剧",
    director: "香港无线电视（TVB）",
    cast: "温碧霞 饰 潘金莲",
    tag: "港剧经典",
    summary:
      "以《金瓶梅》人物为蓝本的电视剧，深宅内院的等级与算计构成全剧底色。潘金莲在其中既是争夺者，也是被环境推着走的人。",
    detail:
      "电视剧的篇幅让潘金莲的处境得以更充分铺陈，她的选择被放在宅门秩序与女性命运的框架中呈现，而非单一的“恶名”。",
    image:
      "https://readdy.ai/api/search-image?query=1990s%20Hong%20Kong%20television%20drama%20promo%20art%2C%20ornate%20classical%20Chinese%20mansion%20interior%20with%20carved%20folding%20screen%2C%20warm%20candlelight%2C%20a%20woman%20in%20rich%20costume%2C%20amber%20and%20crimson%20tones%2C%20painterly%20illustration&width=600&height=800&seq=panjinlian-w03&orientation=portrait",
  },
  {
    id: "xinjinpingmei-1995",
    title: "新金瓶梅",
    year: "1995",
    type: "电影",
    director: "改编自《金瓶梅》",
    cast: "杨思敏 饰 潘金莲",
    tag: "以潘金莲为视角",
    summary:
      "改编幅度较大的商业电影，把叙事重心放在潘金莲身上，用华丽的影像和一以贯之的欲望主题去重构她的人生轨迹。",
    detail:
      "影片对原著情节做了大量取舍，画面风格浓艳，是商业改编中较有代表性的一版，常被用来讨论潘金莲形象的娱乐化倾向。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20an%20ornate%20classical%20Chinese%20bedchamber%20with%20silk%20curtains%20and%20candlelight%2C%20rich%20golden%20glow%2C%20crimson%20drapes%2C%20stylized%20artistic%20illustration%2C%20vintage%20film%20atmosphere%2C%20soft%20shadows&width=600&height=800&seq=panjinlian-w04&orientation=portrait",
  },
  {
    id: "shuihu-1998",
    title: "水浒传",
    year: "1998",
    type: "电视剧",
    director: "中央电视台",
    cast: "王思懿 饰 潘金莲",
    tag: "国民度最高",
    summary:
      "央视版《水浒传》里的潘金莲，是许多观众印象最深的一版。剧集把她的处境放在武松杀嫂的主线之中，塑造出一个被环境和欲望共同推着走的女子。",
    detail:
      "这一版的传播范围极广，王思懿的表演让潘金莲“凄美”的一面被更多人记住，也使相关讨论从单纯的道德评判转向对人物处境的理解。",
    image:
      "https://readdy.ai/api/search-image?query=Classical%20Chinese%20television%20drama%20scene%2C%20a%20woman%20in%20elegant%20Song%20dynasty%20hanfu%20standing%20in%20an%20old%20courtyard%2C%20warm%20natural%20daylight%2C%20muted%20crimson%20and%20earth%20tones%2C%20painterly%20illustration%2C%20soft%20film%20grain&width=600&height=800&seq=panjinlian-w05&orientation=portrait",
  },
  {
    id: "shuihu-2011",
    title: "水浒传",
    year: "2011",
    type: "电视剧",
    director: "鞠觉亮 等",
    cast: "甘婷婷 饰 潘金莲",
    tag: "新版再诠释",
    summary:
      "新版《水浒传》用更现代的表演与造型重新诠释潘金莲，一度引发关于“是否美化了这个角色”的争论，也让她的形象讨论再次回到公共视野。",
    detail:
      "服饰、妆容与镜头语言的更新，使这一版潘金莲更接近当代观众的审美，同时也带来“改编应当忠实到什么程度”的持续讨论。",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20television%20adaptation%20character%20poster%2C%20a%20woman%20in%20refined%20Song%20dynasty%20costume%20with%20pearl%20hairpins%2C%20soft%20studio%20lighting%2C%20crimson%20and%20gold%20palette%2C%20stylized%20illustration%2C%20elegant%20composition&width=600&height=800&seq=panjinlian-w06&orientation=portrait",
  },
];